import { render, staticRenderFns } from "./MessagesModals.vue?vue&type=template&id=6f5440bb"
import script from "./MessagesModals.vue?vue&type=script&lang=js"
export * from "./MessagesModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports